<template>
	<div>
		<b-modal
			id="deleteresume"
			size="md"
			centered
			hide-footer
			hide-header
			v-model="showDelete"
			@hidden="$emit('close-modal')"
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom dpro-flex-1 p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="@/assets/icons/candDashboard/modalDelete.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87 dpro-text">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head dpro-txt-center">
									Delete Resume "{{ localCandidateInfo.profileName }}"
								</div>
								<div
									id="hideinmobile"
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$emit('close-modal')"
								>
									<img
										class="rotate-on-hover"
										src="@/assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3 dpro-txt-center">
								Deleting the resume will delete your entire profile. This action
								cannot be undone?
							</div>
						</div>
					</div>

					<div
						class="p-3 dpro-border-top d-flex align-items-center dpro-justify-cont"
					>
						<b-button
							class="candash-cancelBtn mr-4 dpro-40"
							@click="$emit('close-modal')"
							>Cancel</b-button
						>

						<div class="position-relative dpro-40">
							<b-button
								class="candash-addBtn dpro-100"
								:class="
									isDeletingResume
										? 'loader-class-delete-2 defaultCursor'
										: 'pointer'
								"
								@click="isDeletingResume ? null : deleteNormalProfile()"
								>{{ isDeletingResume ? "" : "Delete" }}</b-button
							>
							<div v-if="isDeletingResume" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="deletePrimaryProfile"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showDeletePrimary"
			@hidden="$emit('close-modal')"
		>
			<div id="hideinmobile" class="candash-modal-top p-3">
				<div class="mb-header-txt">Delete Primary Profile</div>

				<img
					class="rotate-on-hover pointer"
					src="@/assets/newdesign/dashboard/blueCross.svg"
					alt=""
					@click="$emit('close-modal')"
				/>
			</div>
			<div class="dpro-candash-modal-body">
				<div class="d-flex align-items-center mb-header-txt dpro-flex-1">
					<img
						class="mr-3"
						src="@/assets/New Profile/warning-icon.svg"
						alt=""
					/>
					<span id="hideinmobile"
						>You are about to delete your Primary Profile</span
					>
					<span id="hideinlaptop" class="mt-3">Delete Primary Profile </span>
				</div>
				<div class="candash-light-txt-2 dpro-txt-center mt-2 pl-1">
					Please choose another primary profile before proceeding
				</div>
				<div class="dpp-overflow pl-2 mt-3 pr-3">
					<div v-for="(profile, index) in allProfiles" :key="index">
						<div
							class="candash-displaytxt-grey-3 d-flex align-items-center text-truncate mb-3"
							v-if="!profile.primary"
						>
							<b-form-radio
								size="md"
								:class="{
									'pad-radio2': profile._id === selectedProfile,
								}"
								:value="profile._id"
								v-model="selectedProfile"
							>
								<img
									class="ml-1 mr-2"
									src="@/assets/newdesign/dashboard/docBlue.svg"
									alt=""
								/>
								{{ profile.profileName }}
							</b-form-radio>
						</div>
						<hr
							v-if="index !== 0 && index !== allProfiles.length - 1"
							id="hideinlaptop"
							class="hr-back"
						/>
					</div>
				</div>
			</div>
			<div
				class="candash-modal-footer d-flex align-items-center dpro-justify-cont"
			>
				<b-button
					@click="$emit('close-modal')"
					class="candash-cancelBtn mr-4 pointer dpro-40"
					>Cancel
				</b-button>
				<div class="position-relative dpro-40">
					<b-button
						class="candash-addBtn pointer dpro-100"
						:class="
							isDeletingPrimary
								? '  loader-class-delete-2 defaultCursor '
								: ' pointer'
						"
						@click="isDeletingPrimary ? '' : deletePrimaryProfile()"
						:disabled="!selectedProfile"
						>{{ isDeletingPrimary ? "" : "Delete" }}</b-button
					>
					<div v-if="isDeletingPrimary" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Loader from "@/components/fixedcomponents/Loader.vue";
import successModal from "@/components/mixin/toast";
import errorModal from "@/components/mixin/toast";
import {
	deleteNormalProfile,
	deletePrimaryProfile,
	switchProfile,
	getAllProfiles,
} from "@/utils/apiFunctions";
export default {
	name: "DeleteProfile",
	props: {
		localCandidateInfo: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			showDelete: false,
			showDeletePrimary: false,
			isDeletingResume: false,
			isDeletingPrimary: false,
			selectedProfile: "",
			allProfiles: [],
		};
	},
	mixins: [successModal, errorModal],
	async created() {
		await this.openDeleteModal();
	},
	components: {
		Loader,
	},
	methods: {
		async openDeleteModal() {
			if (this.localCandidateInfo.primary) {
				this.showDeletePrimary = true;
				this.getAllProfiles();
			} else {
				this.showDelete = true;
			}
		},
		async deletePrimaryProfile() {
			this.isDeletingPrimary = true;
			try {
				const res = await deletePrimaryProfile({
					id: this.localCandidateInfo._id,
					newPrimary: this.selectedProfile,
				});
				if (res.status === 200) {
					this.successModal(
						"Successfully deleted.",
						"Profile has been deleted."
					);

					this.localCandidateInfo = (await switchProfile()).data.data;
					this.$store.commit(
						"candidateVUEX/setCandidateInfo",
						this.localCandidateInfo
					);
					this.selectedProfile = "";
					// this.setProfileId(this.localCandidateInfo._id);
					this.getAllProfiles();
					this.$emit(
						"update-profile",
						this.localCandidateInfo.primaryProfile.id
					);
					this.$router.push({
						name: "CandidateDashboard",
					});
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
			} finally {
				this.isDeletingPrimary = false;
				this.$emit("close-modal");
			}
		},
		async deleteNormalProfile() {
			this.isDeletingResume = true;
			try {
				const res = await deleteNormalProfile({
					id: this.localCandidateInfo._id,
				});
				if (res.status === 200) {
					this.successModal(
						"Successfully deleted.",
						"Profile has been deleted."
					);
					this.localCandidateInfo = (await switchProfile()).data.data;
					this.$store.commit(
						"candidateVUEX/setCandidateInfo",
						this.localCandidateInfo
					);
					console.log(this.localCandidateInfo,"localCandidateInfo");
					this.$emit(
						"update-profile",
						this.localCandidateInfo.primaryProfile.id
					);
					this.getAllProfiles();
					this.$router.push({
						name: "CandidateDashboard",
					});
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
			} finally {
				this.isDeletingResume = false;
				this.$emit("close-modal");
			}
		},
		async getAllProfiles() {
			this.allProfiles = (await getAllProfiles()).data.data.map((profile) => {
				return {
					profileName: profile.profileName,
					_id: profile._id,
					primary: profile.primary,
				};
			});
		},
	},
};
</script>
<style>
.dpro-justify-cont {
	justify-content: flex-end;
}
.dpro-border-top {
	border: 1px solid #ffffff;
}
.loader-class-delete-2 {
	opacity: 0.5;
	height: 31px;
	width: 109px;
}

.loader-class-delete-2:focus,
.loader-class-delete-2:hover {
	width: 109px;
}
.dpro-candash-modal-body {
	padding: 15px 40px 15px 15px;
}
@media (max-width: 1028px) {
	.dpro-flex-1 {
		flex-direction: column;
		align-items: center;
	}
	.dpro-text {
		padding-left: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 15px;
	}
	.dpro-txt-center {
		text-align: center;
	}
	.dpro-justify-cont {
		justify-content: center;
	}
	.dpro-border-top {
		border: 1px solid #d9d9d9;
	}
	.dpro-40 {
		width: 45%;
	}
	.dpro-100 {
		width: 100%;
	}
	.loader-class-delete-2 {
		opacity: 0.5;
		height: 31px;
		width: 100%;
	}

	.loader-class-delete-2:focus,
	.loader-class-delete-2:hover {
		width: 100%;
	}
	.dpro-candash-modal-body {
		padding: 15px;
	}
}
</style>
